import { fetchData, consoleDev, ConsoleStatus } from '@quizzach/utils';
import { useState } from 'react';

export const usePay = () => {
	const [error, setError] = useState<boolean>(false);

	const handleFakePay = async () => {
		try {
			const response = await fetchData<any>(
				`/api/cart/quizzach-pay`,
				{
					method: 'POST',
					body: JSON.stringify({}),
				},
				{
					authRoute: true,
				}
			);
			if (response.status >= 300) {
				consoleDev('fakePay', ConsoleStatus.HTTP, response.status);
				setError(true);
				return false;
			} else {
				consoleDev('fakePay', ConsoleStatus.SUCC);
				setError(false);
				return true;
			}
		} catch (err) {
			consoleDev('fakePay', ConsoleStatus.NET, err);
			setError(true);
			return false;
		}
	};
	return { handleFakePay, error };
};
